import { Td } from '@patternfly/react-table';
import React from 'react';
import { DeploymentRepresentation, useGetDeploymentMetrics } from 'src/query/deployments';
import { columnNames, healthIcon } from './deployment-table';

export const Metrics = ({ deployment }: { deployment: DeploymentRepresentation }) => {
  const { data: deployMetrics = {} } = useGetDeploymentMetrics(
    {
      pathParams: { realm: 'self', deploymentId: deployment.id },
    },
    { staleTime: 5000 }
  );

  return (
    <>
      <Td dataLabel={columnNames.users}>{deployMetrics.counts?.users || '--'}</Td>
      <Td dataLabel={columnNames.users}>{deployMetrics.counts?.sessions || '--'}</Td>
      <Td dataLabel={columnNames.sso}>{deployMetrics.counts?.idps || '--'}</Td>
      <Td dataLabel={columnNames.state}>{healthIcon(deployMetrics) || '--'}</Td>
    </>
  );
};
